// Display-only helpers. Permissions and result validation remain server-side.
const labels = {
  category: ['组别', '組別', 'Category'],
  REVIEWED_CLUB_LINK: ['已审核俱乐部关联', '已審核俱樂部關聯', 'Approved club link'],
  registration: ['线上报名', '線上報名', 'Online registration'],
  registrationHelp: ['按需开启。审核通过的队伍进入本赛事参赛清单；也可直接添加或导入对阵表。', '按需開啟。審核通過的隊伍進入本賽事參賽清單；也可直接新增或匯入對陣表。', 'Optional. Approved teams join this event’s entries. You can also add entries or import a draw.'],
  registrationOff: ['线上报名未开启，可直接在参赛队伍中添加队伍。已有报名与名单继续保留；需要接收新报名时，在编辑赛事中开启。', '線上報名未開啟，可直接在參賽隊伍中新增隊伍。已有報名與名單繼續保留；需要接收新報名時，在編輯賽事中開啟。', 'Online registration is off. Add entries directly in Teams. Existing applications and rosters are retained; edit the event to accept new applications.'],
  registrationReview: ['报名管理', '報名管理', 'Registration'],
  entryHelp: ['报名、直接添加和对阵表导入的队伍汇集于此。队伍编号仅用于本赛事组别，不是个人桨刻号。', '報名、直接新增和對陣表匯入的隊伍匯集於此。隊伍編號僅用於本賽事組別，不是個人槳刻號。', 'Approved registrations, manually added teams and imported entries share this list. Entry codes identify a team in this event category, not a person.'],
  entrySource: ['来源', '來源', 'Source'],
  sourceRegistration: ['报名审核', '報名審核', 'Approved registration'],
  sourceDraw: ['直接添加／对阵表', '直接新增／對陣表', 'Added / imported'],
  registeredEntryHelp: ['此队伍已关联报名记录，编号与队伍身份在这里保持固定。', '此隊伍已關聯報名記錄，編號與隊伍身份在這裡保持固定。', 'This entry is linked to a registration. Its code and team identity are fixed here.'],
  unlinkedLegacy: ['本场包含尚未关联参赛队伍的历史成绩，原始记录已保留。请先核对原始报名或对阵资料；在明确关联前，相关记录暂不可编辑或删除，本场也不可重新发布。', '本場包含尚未關聯參賽隊伍的歷史成績，原始記錄已保留。請先核對原始報名或對陣資料；在明確關聯前，相關記錄暫不可編輯或刪除，本場也不可重新發布。', 'This race contains historical results without a verified event-entry link. Original records are retained. Check the source registration or draw first; these records cannot be edited or deleted, and this race cannot be republished until the links are verified.'],
  unlinkedRecord: ['历史关联待核对', '歷史關聯待核對', 'Historical link needs review'],
  batchEditor: ['批量编排', '批量編排', 'Batch editor'],
  raceEditor: ['场次编辑', '場次編輯', 'Race editor'],
  points: ['积分与汇总', '積分與匯總', 'Points & totals'],
  classification: ['两航道换道成绩', '兩航道換道成績', 'Two-lane classification'],
  centerHelp: ['按赛事规程选择输出。积分榜沿用已设置的积分规则；两轮累计仅适用于两航道、两轮换道计时规则，不会自动重算其他成绩。', '按賽事規程選擇輸出。積分榜沿用已設定的積分規則；兩輪累計僅適用於兩航道、兩輪換道計時規則，不會自動重算其他成績。', 'Choose the output required by your event rules. Points retain the configured scoring rules. Combined times apply only to two-lane, two-round lane-swap races and do not recalculate other results.'],
  claims: ['参赛经历认领', '參賽經歷認領', 'Participation claims'],
  claimsHelp: ['独立开关；启用后仍需指定可信领队，扫码不授予权限。', '獨立開關；啟用後仍需指定可信領隊，掃碼不授予權限。', 'Optional. Appoint a verified team leader; scanning a link never grants authority.'],
  noRoster: ['可先安排赛程、录入裁判确认的成绩，之后再补充队员关系与名单。', '可先安排賽程、錄入裁判確認的成績，之後再補充隊員關係與名單。', 'Schedule races and record judge-confirmed results first. Participant links and rosters can be added later.'],
  workspace: ['赛程与成绩', '賽程與成績', 'Schedule & results'],
  entries: ['参赛队伍', '參賽隊伍', 'Event entries'],
  category: ['组别', '組別', 'Category'],
  race: ['场次', '場次', 'Race'],
  selectCategory: ['请选择组别', '請選擇組別', 'Select a category'],
  selectRace: ['请选择场次', '請選擇場次', 'Select a race'],
  categoryFirst: ['请先在组别配置中建立对阵表上的组别。', '請先在組別配置中建立對陣表上的組別。', 'Create the categories from the draw in Category setup first.'],
  newRace: ['新增场次', '新增場次', 'Add race'],
  editRace: ['调整场次', '調整場次', 'Edit race'],
  raceStatus: ['场次状态', '場次狀態', 'Race status'],
  raceState0: ['准备中', '準備中', 'Scheduled'],
  raceState1: ['进行中', '進行中', 'In progress'],
  raceState2: ['已结束', '已結束', 'Finished'],
  raceState3: ['已取消（保留历史）', '已取消（保留歷史）', 'Cancelled (history retained)'],
  removeDraft: ['移除草稿行', '移除草稿行', 'Remove draft row'],
  removeHelp: ['仅移除此场从未发布的对阵行，保留队伍及审计；曾发布的成绩不可删除。', '僅移除此場從未發布的對陣行，保留隊伍及審計；曾發布的成績不可刪除。', 'Remove this never-published draw row only. Keep the entry and audit trail; previously published results cannot be deleted.'],
  raceName: ['场次名称', '場次名稱', 'Race name'],
  raceTime: ['比赛时间（可留空）', '比賽時間（可留空）', 'Start time (optional)'],
  distance: ['距离（米，可留空）', '距離（米，可留空）', 'Distance (metres, optional)'],
  pending: ['待定', '待定', 'To be confirmed'],
  upcoming: ['待开赛', '待開賽', 'Upcoming'],
  addEntry: ['添加参赛队伍', '新增參賽隊伍', 'Add event entry'],
  addRow: ['添加对阵行', '新增對陣行', 'Add draw row'],
  paste: ['粘贴对阵表', '貼上對陣表', 'Paste draw rows'],
  pasteHelp: ['从 Excel 复制三列：队伍编号、队名、航道/对阵位（可空）。编号仅在本组别内识别队伍，不是桨刻号。先预览，确认后才写入。', '從 Excel 複製三欄：隊伍編號、隊名、航道/對陣位（可空）。編號僅在本組別內識別隊伍，不是槳刻號。先預覽，確認後才寫入。', 'Copy three columns: entry code, team name, lane/position (optional). Codes identify entries in this category, not people. Preview before importing.'],
  preview: ['预览', '預覽', 'Preview'],
  importConfirm: ['确认导入对阵', '確認匯入對陣', 'Import reviewed draw'],
  entryCode: ['队伍编号', '隊伍編號', 'Entry code'],
  teamName: ['队名', '隊名', 'Team name'],
  lane: ['航道／对阵位', '航道／對陣位', 'Lane / position'],
  bib: ['显示编号', '顯示編號', 'Display number'],
  rank: ['裁判名次', '裁判名次', 'Official place'],
  time: ['成绩时间', '成績時間', 'Time'],
  state: ['成绩状态', '成績狀態', 'Result status'],
  accessState: ['授权状态', '授權狀態', 'Access status'],
  claimState: ['认领状态', '認領狀態', 'Claim status'],
  FINISHED: ['正常完赛', '正常完賽', 'Finished'],
  DNS: ['未出发 DNS', '未出發 DNS', 'Did not start'],
  DNF: ['未完赛 DNF', '未完賽 DNF', 'Did not finish'],
  DSQ: ['取消资格 DSQ', '取消資格 DSQ', 'Disqualified'],
  remark: ['裁判说明', '裁判說明', 'Judge notes'],
  published: ['已发布', '已發布', 'Published'],
  draft: ['未发布', '未發布', 'Unpublished'],
  action: ['操作', '操作', 'Actions'],
  edit: ['编辑', '編輯', 'Edit'],
  save: ['保存', '儲存', 'Save'],
  saveDraft: ['保存未发布成绩', '儲存未發布成績', 'Save unpublished result'],
  publish: ['复核并发布本场', '覆核並發布本場', 'Review & publish race'],
  publishHelp: ['请与裁判原始成绩单核对。系统不自动判定名次或晋级；所有时间、名次及异常状态由录入者确认。', '請與裁判原始成績單核對。系統不自動判定名次或晉級；所有時間、名次及異常狀態由錄入者確認。', 'Check against the judges’ results. Places and advancement are not calculated automatically. Confirm every time, place and status.'],
  correction: ['更正理由', '更正理由', 'Correction reason'],
  correctionHelp: ['更正已发布成绩须填写理由并保留历史；保存后需要重新复核发布。', '更正已發布成績須填寫理由並保留歷史；儲存後需要重新覆核發布。', 'Changes to published results require a reason and retain history. Review and publish again after saving.'],
  refresh: ['刷新', '重新整理', 'Refresh'],
  saved: ['已保存', '已儲存', 'Saved'],
  failed: ['操作失败，输入已保留', '操作失敗，輸入已保留', 'Action failed. Your input is retained.'],
  required: ['请填写必填项目', '請填寫必填項目', 'Complete the required fields'],
  representative: ['绑定领队', '綁定領隊', 'Assign team leader'],
  leaderSource: ['关联来源', '關聯來源', 'Access source'],
  REGISTRATION_LEADER: ['原报名队伍领队', '原報名隊伍領隊', 'Existing registered team leader'],
  EVENT_ASSIGNMENT: ['本赛事绑定', '本賽事綁定', 'Event assignment'],
  representativeHelp: ['已有报名队伍沿用现任领队；对阵表队伍经核实后绑定。本入口管理本赛事、本队的参与确认与选座协作，不授予俱乐部管理、正式名单或成绩修改权限。', '已有報名隊伍沿用現任領隊；對陣表隊伍經核實後綁定。本入口管理本賽事、本隊的參與確認與選座協作，不授予俱樂部管理、正式名單或成績修改權限。', 'Registered teams reuse their current leader. Verify and assign a leader for imported teams. Access covers this event team’s participation and seating collaboration, not club ownership, official rosters or results editing.'],
  jiangkNo: ['领队永久桨刻号', '領隊永久槳刻號', 'Representative’s permanent JiangK ID'],
  evidence: ['核实依据／撤销理由', '核實依據／撤銷理由', 'Verification / revocation note'],
  active: ['启用', '啟用', 'Active'],
  inactive: ['已撤销', '已撤銷', 'Revoked'],
  revokeAccess: ['撤销权限', '撤銷權限', 'Revoke access'],
  all: ['全部队伍', '全部隊伍', 'All entries'],
  claimant: ['申请人', '申請人', 'Claimant'],
  role: ['角色', '角色', 'Role'],
  submitted: ['申请时间', '申請時間', 'Submitted'],
  PENDING: ['待确认', '待確認', 'Pending'],
  CONFIRMED: ['参赛关系已确认', '參賽關係已確認', 'Participation confirmed'],
  REJECTED: ['未通过', '未通過', 'Rejected'],
  WITHDRAWN: ['本人已撤回', '本人已撤回', 'Withdrawn'],
  REVOKED: ['确认已撤销', '確認已撤銷', 'Confirmation revoked'],
  confirm: ['确认参与', '確認參與', 'Confirm participation'],
  reject: ['不通过', '不通過', 'Reject'],
  revoke: ['撤销确认', '撤銷確認', 'Revoke confirmation'],
  review: ['复核认领', '覆核認領', 'Review claim'],
  history: ['变更记录', '變更記錄', 'Change history'],
  claimsOff: ['认领当前关闭。已有记录保留，可撤销错误确认；开启请编辑赛事。', '認領目前關閉。已有記錄保留，可撤銷錯誤確認；開啟請編輯賽事。', 'Claims are disabled. Existing records are retained and incorrect confirmations can be revoked. Edit the event to enable intake.'],
  scope: ['仅确认本赛事的队伍参与关系，不代表每轮上船、个人成绩或官方证书。', '僅確認本賽事的隊伍參與關係，不代表每輪上船、個人成績或官方證書。', 'Confirms event-team participation only, not participation in every race, individual times or an official certificate.'],
  PADDLER: ['划手', '划手', 'Paddler'],
  DRUMMER: ['鼓手', '鼓手', 'Drummer'],
  STEERER: ['舵手', '舵手', 'Steerer'],
  SUBSTITUTE: ['替补', '替補', 'Substitute'],
  OTHER: ['其他', '其他', 'Other'],
  source: ['对阵表中的队名按原文保存，不自动合并同名俱乐部。', '對陣表中的隊名按原文儲存，不自動合併同名俱樂部。', 'Team names retain the draw’s wording; matching names never merge clubs automatically.']
}

export function resultsText(locale, key) {
  const values = labels[key]
  return values ? values[locale === 'en' ? 2 : locale === 'zh-Hant' ? 1 : 0] : key
}

export function registrationEnabled(event) {
  if (!event) return false
  return event.registrationEnabled == null ? event.serviceMode !== 'RESULTS_ONLY' : Number(event.registrationEnabled) === 1
}

export function parseDrawPaste(text, existingEntries = [], categoryId) {
  const lines = String(text || '').replace(/^\uFEFF/, '').split(/\r?\n/).filter(line => line.trim())
  if (!lines.length) throw new Error('请粘贴对阵表内容 / Paste draw rows first')
  if (lines.length > 201) throw new Error('每次最多 200 行 / Maximum 200 rows per import')
  const codes = new Set()
  const lanes = new Set()
  const rows = []
  lines.forEach((line, index) => {
    const cols = line.split('\t').map(value => value.trim())
    if (index === 0 && /^(队伍编号|隊伍編號|entry code)$/i.test(cols[0]) && /^(队名|隊名|team name)$/i.test(cols[1] || '')) return
    if (cols.length < 2 || cols.length > 3 || !cols[0] || !cols[1]) throw new Error(`第 ${index + 1} 行：需要编号、队名及可选航道 / Code, name, optional lane required`)
    const [entryCode, teamName, lane] = cols
    if (!/^[A-Za-z0-9_-]{1,40}$/.test(entryCode) || teamName.length > 100) throw new Error(`第 ${index + 1} 行：编号限40位字母、数字、横线；队名限100字 / Invalid code or name length`)
    if (codes.has(entryCode.toLowerCase())) throw new Error(`第 ${index + 1} 行：队伍编号重复 / Duplicate entry code`)
    const laneNo = lane ? Number(lane) : null
    if (lane && (!/^\d+$/.test(lane) || !Number.isSafeInteger(laneNo) || laneNo < 1 || laneNo > 999)) throw new Error(`第 ${index + 1} 行：航道应为正整数 / Invalid lane`)
    if (laneNo && lanes.has(laneNo)) throw new Error(`第 ${index + 1} 行：航道重复 / Duplicate lane`)
    const existing = existingEntries.find(entry => Number(entry.categoryId) === Number(categoryId) && String(entry.entryCode).toLowerCase() === entryCode.toLowerCase())
    if (existing && existing.teamName !== teamName) throw new Error(`第 ${index + 1} 行：已有编号对应另一队名，请先核对 / Existing code has a different name`)
    codes.add(entryCode.toLowerCase())
    if (laneNo) lanes.add(laneNo)
    rows.push({ entryCode, teamName, laneNo, eventEntryId: existing ? existing.id : null })
  })
  if (!rows.length || rows.length > 200) throw new Error('需要 1–200 行对阵 / Supply 1–200 draw rows')
  return rows
}
